var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Exception',{attrs:{"type":"404"}})
}
var staticRenderFns = []

export { render, staticRenderFns }